export class FolderHierarchy {
    id: number;
    name: string;
    parent: FolderHierarchy;
    creationTimestamp: Date | string;
    createdBy: string;

    static parseFrom(data: any): FolderHierarchy {
        var res = new FolderHierarchy();
        res.id = data.Id;
        res.name = data.Name;
        res.creationTimestamp = data.CreationTimestamp;
        res.createdBy = data.CreatedBy;
        if (data.Parent) {
            res.parent = FolderHierarchy.parseFrom(data.Parent);
        }

        return res;
    }
}
